import type { HostListStats } from '@/types/communityHost';

interface HostManagementHeaderStatsProps {
  stats?: HostListStats;
}

export function HostManagementHeaderStats({ stats }: HostManagementHeaderStatsProps) {
  const total = stats?.total_pengelola ?? 0;
  const coHost = stats?.co_host_aktif ?? 0;

  return (
    <div className="grid grid-cols-2 gap-3">
      <div className="bg-white rounded-2xl p-4 border border-[#E0E6ED] shadow-2xs flex flex-col gap-1">
        <span className="text-xs font-semibold text-gray-500">Total Pengelola</span>
        <span className="text-xl font-extrabold text-[#0E1726]">{total}</span>
      </div>
      <div className="bg-white rounded-2xl p-4 border border-[#E0E6ED] shadow-2xs flex flex-col gap-1">
        <span className="text-xs font-semibold text-gray-500">Co-Host Aktif</span>
        <span className="text-xl font-extrabold text-[#FC480D]">{coHost}</span>
      </div>
    </div>
  );
}
